<template>
<div>
    <kn-jumbotron></kn-jumbotron>
    <b-container fluid>
    <b-row>
    <kn-sideMenu></kn-sideMenu>
    <main role="main" class="ml-sm-auto pt-3 px-4 mx-auto col-md-9" >
      <h2><span class="Block blue"></span>Κιμωλιακή Βιβλιοθήκη</h2>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-1 variant="info">ΟΙ ΦΛΕΕΣ ΤΟΥ ΓΙΩΡΓΗΛΑ</b-btn>
      </b-card-header>
      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/giorgilas.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-2 variant="info">ΚΙΜΩΛΙΑΚΩΝ ΠΑΡΟΙΜΙΩΝ ΤΟ ΑΝΑΓΝΩΣΜΑ</b-btn>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/kimoliakon_paroimion.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-3 variant="info">H ΕΚΠΑΙΔΕΥΤΙΚΗ ΑΝΟΙΞΗ ΣΤΟ ΝΗΣΙ ΤΗΣ ΚΙΜΩΛΟΥ (1823-1854)</b-btn>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/anoiksi.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-4 variant="info">ΑΝΤΩΝΙΟΣ ΒΑΣ. ΣΑΡΔΗΣ ΟΙΚΟΝΟΜΟΣ ΚΙΜΩΛΟΥ - ΦΙΛΙΚΟΣ (1772-1843)</b-btn>
      </b-card-header>
      <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/antonios_sardis.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-5 variant="info">Ο ΝΑΟΣ ΤΟΥ ΣΩΤΗΡΟΣ ΧΡΙΣΤΟΥ ΚΙΜΩΛΟΥ ΚΑΙ Ο ΠΡΕΣΒΥΤΕΡΟΣ ΜΑΡΚΟΣ Ν. ΒΕΝΤΟΥΡΗΣ</b-btn>
      </b-card-header>
      <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/naos_sotiros.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-6 variant="info">10η ΣΥΝΑΝΤΗΣΗ ΚΥΚΛΑΔΙΚΟΥ ΤΥΠΟΥ</b-btn>
      </b-card-header>
      <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/10_sinantisi.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-7 variant="info">ΕΜΕΝΑ ΜΕ ΞΕΡΟΥΝ Ο ΔΑΣΚΑΛΟΣ</b-btn>
      </b-card-header>
      <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/troullos.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-8 variant="info">ΚΙΜΩΛΙΑΚΑ ΙΣΤΟΡΙΚΑ ΘΕΜΑΤΑ</b-btn>
      </b-card-header>
      <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/kimoliaka_istorika.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-9 variant="info">ΜΙΜΗΣ ΑΝΤ. ΑΦΕΝΤΑΚΗΣ 1903-1959 - Ο Κιμώλιος ευπατρίδης και οραματιστής</b-btn>
      </b-card-header>
      <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
          <p class="card-text">
          <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/afentakis.pdf"
            allowfullscreen>
          </b-embed>
          </p>  
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-10 variant="info">ΟΙΚΟΝΟΜΙΚΗ ΖΩΗ ΚΑΙ ΕΠΑΓΓΕΛΜΑΤΑ ΤΗΣ ΚΙΜΩΛΟΥ</b-btn>
      </b-card-header>
      <b-collapse id="accordion-10" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/oikonomiki_zoi.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-11 variant="info">ΠΕΡΙ ΤΗΣ ΙΕΡΑΣ ΑΡΧΙΕΠΙΣΚΟΠΗΣ ΜΗΛΟΥ ΚΑΙ ΚΙΜΩΛΟΥ ΚΑΙ ΑΝΙΔΡΥΣΗΣ ΜΗΤΡΟΠΟΛΕΩΣ ΣΙΦΝΟΜΗΛΟΥ</b-btn>
      </b-card-header>
      <b-collapse id="accordion-11" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/arxiepiskopi.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-12 variant="info">H ΑΥΤΟΔΙΟΙΚΗΣΗ ΤΗΣ ΚΙΜΩΛΟΥ Α' ΜΕΡΟΣ: 1920-1950</b-btn>
      </b-card-header>
      <b-collapse id="accordion-12" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/autodioikisi_a.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-13 variant="info">H ΑΥΤΟΔΙΟΙΚΗΣΗ ΤΗΣ ΚΙΜΩΛΟΥ Β' ΜΕΡΟΣ: 1951-1982</b-btn>
      </b-card-header>
      <b-collapse id="accordion-13" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/autodioikisi_b.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-14 variant="info">H ΑΥΤΟΔΙΟΙΚΗΣΗ ΤΗΣ ΚΙΜΩΛΟΥ Γ' ΜΕΡΟΣ: 1983-2010</b-btn>
      </b-card-header>
      <b-collapse id="accordion-14" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/autodioikisi_c.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-15 variant="info">ΚΙΜΩΛΙΑΚΑ ΙΣΤΟΡΙΚΑ ΔΙΑΦΟΡΑ</b-btn>
      </b-card-header>
      <b-collapse id="accordion-15" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/kimoliaka_istorika_diafora.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion-16 variant="info">ΛΕΞΕΙΣ ΤΗΣ ΚΙΜΩΛΟΥ</b-btn>
      </b-card-header>
      <b-collapse id="accordion-16" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <p class="card-text">
            <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" src="https://www.kimoliaka-nea.gr/vivlia/Lexeis_tis_Kimolou.pdf"
            allowfullscreen>
          </b-embed>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
    </main>
    </b-row>
    </b-container>
    <kn-footer></kn-footer>
</div>



</template>

<script>
import jumbotron from "./jumbotron.vue";
import sideMenu from "./sideMenu.vue";
import footer from "./footer.vue";
export default {
    components: {
    "kn-jumbotron": jumbotron,
    "kn-sideMenu": sideMenu,
    "kn-footer": footer
  }
}
</script>


<style>

</style>


// WEBPACK FOOTER //
// src/components/books.vue